import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LifecycleStage } from '@vendasta/account-group';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class LifecycleOptionsDisplayService implements DataFilterDisplayService {
  constructor(private readonly translateService: TranslateService) {}
  getDisplay(value: any): Observable<string> {
    let key: string;
    switch (value) {
      case LifecycleStage.LIFECYCLE_STAGE_LEAD:
        key = 'COMMON.LIFE_CYCLE_STAGES.LEAD';
        break;
      case LifecycleStage.LIFECYCLE_STAGE_PROSPECT:
        key = 'COMMON.LIFE_CYCLE_STAGES.PROSPECT';
        break;
      case LifecycleStage.LIFECYCLE_STAGE_CUSTOMER:
        key = 'COMMON.LIFE_CYCLE_STAGES.CUSTOMER';
        break;
      default:
        key = 'AUTOMATIONS.EDITOR.ERRORS.STEP_MISSING_DATA';
    }

    return this.translateService.stream(key).pipe(take(1));
  }
}
